<template>
  <v-dialog v-model="dialog" width="800" scrollable>
    <v-card flat>
      <v-card-title class="pa-0">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-alert type="info" text v-if="[].concat(...Object.values(selected)).length">
          <div>
            <span class="red--text">{{ [].concat(...Object.values(selected)).length }} {{ subtitle }}</span>
            Terpilih
          </div>
        </v-alert>
        <base-table-header @search="onSearch" @reload="onReload">
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }}</b> {{ subtitle || '-' }}
            </div>
          </template>
          <template v-if="options && options.gelombang" v-slot:toolbar>
            <div style="width: 150px">
              <v-select
                v-model="gelombang"
                class="mt-7"
                light
                flat
                dense
                outlined
                :items="options.mGelombang"
                @change="onChangeGelombang"
              ></v-select>
            </div>
          </template>
        </base-table-header>
        <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
          <template slot-scope="{ item }">
            <td :style="`backgroundColor: ${!disable ? '' : allow(item) ? '#dcdcdc' : ''}`">
              <v-list-item dense :disabled="!disable ? false : allow(item)" class="px-0" @click="onSelect(item)">
                <v-list-item-content>
                  <v-row>
                    <v-col v-if="multiselect" cols="12" md="1" sm="1" class="px-5">
                      <div
                        class="v-input theme--light v-input--selection-controls v-input--checkbox"
                        style="margin-top:10px"
                      >
                        <label class="container">
                          <input
                            type="checkbox"
                            :value="item.id"
                            v-model="selected[page]"
                            @click="onSelectItem(item)"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </v-col>
                    <v-col v-for="(field, f) in fields" :key="f" v-bind="field.grid">
                      <v-list-item class="px-0">
                        <v-list-item-avatar v-if="field.icon" color="secondary">
                          <v-icon dark>{{ field.icon }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <div class="caption" v-html="field.title" />
                          <template v-if="field && field.list && field.list.length">
                            <div v-for="(list, l) in field.list" :key="l" :class="`${list.class}`">
                              <div v-if="list.keys">
                                <span class="font-weight-medium">{{ $getDeepObj(list, 'label') }}</span>
                                {{
                                  $getDeepObj(item, list.keys[0] || '') || $getDeepObj(item, list.keys[1] || '') || ''
                                }}
                              </div>
                              <div v-else-if="list.tipe && list.tipe === 'status'">
                                <v-chip
                                  dark
                                  outlined
                                  small
                                  :color="$getDeepObj(item, list.status) ? list.clrTrue : list.clrFalse"
                                >
                                  {{ $getDeepObj(item, list.status) ? list.vTrue : list.vFalse }}
                                </v-chip>
                              </div>
                              <div v-else> {{ $getDeepObj(list, 'label') }} {{ $getDeepObj(item, list.key) }}</div>
                            </div>
                          </template>
                          <template v-else>
                            <div>{{ $getDeepObj(item, field.key) }}</div>
                          </template>
                          <span v-if="!disable ? false : allow(item)" class="red--text label--text">
                            {{ labelDisable }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
        <v-divider />
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
      </v-card-actions>
      <v-card-text v-if="multiselect" style="overflow: hidden" class="my-2">
        <div class="text-right">
          <v-btn text @click="dialog = false">Batal</v-btn>
          <v-btn color="primary" :disabled="![].concat(...Object.values(selected)).length" @click="onSaveSelection">
            {{ lblBtnSave }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
export default {
  mixins: [list],
  props: {
    api: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: '',
    },
    disable: {
      type: String,
      default: null,
    },
    labelDisable: {
      type: String,
      default: null,
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    lblBtnSave: {
      type: String,
      default: 'Simpan',
    },
    useDetail: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      fields: [],
      selected: {},
      cache: {},
      gelombang: null,
    };
  },

  computed: {
    subtitle() {
      const title = this.title.split(' ');
      title.splice(0, 1);
      return title.join(' ');
    },
  },

  methods: {
    fetchData() {
      let gelombang = {};
      if (this.options && this.options.gelombang) {
        gelombang = { gelombang: this.gelombang };
      }

      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {}, gelombang);
      this.$store
        .dispatch(this.api, { params: params, id: this.id })
        .then(({ data, per_page, current_page, last_page, total, meta }) => {
          this.data = data || [];
          this.total = meta?.total || total || data.length || 0;
          this.pageTotal = meta?.last_page || last_page || 1;
          this.params.limit = meta?.per_page || per_page || this.params.limit;
          this.page = meta?.current_page || current_page || this.params.page;

          // init selected page
          this.$set(this.selected, this.page, this.selected[this.page] || []);
        });
    },

    open(fields, params = {}, selected = []) {
      this.dialog = true;
      this.fields = fields || [];
      this.params = params || {};
      this.data = [];
      this.gelombang = (this.options && this.options.gelombang) || null;
      this.cache = {};

      this.$set(this.selected, this.page || 1, selected || []);
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect(item) {
      if (this.multiselect) return;
      this.resolve(item);
      this.dialog = false;
    },

    allow(item) {
      const status = this.$getDeepObj(item, `${this.disable}.data`) || [];

      return status.length > 0;
    },

    onSaveSelection() {
      // filtered data
      const selected = [].concat(...Object.values(this.selected));
      let item = {};
      for (const key in this.cache) {
        if (selected.includes(Number(key))) item[key] = this.cache[key];
      }

      this.resolve(this.useDetail ? item : selected);
      this.dialog = false;
    },

    onSelectItem(item) {
      this.cache[item.id] = item;
    },

    onChangeGelombang(value) {
      this.gelombang = value;
      this.fetchData();
    },
  },
};
</script>
<style scoped>
/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
